(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
      if (!this.track || this.slides.length < 2) return;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.thumbIndex);
          this.slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          this.setActive(index);
        });
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = Number(entry.target.dataset.slideIndex);
            this.setActive(index);
          });
        },
        { root: this.track, threshold: 0.6 }
      );

      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    setActive(index) {
      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  class OfferSelector extends HTMLElement {
    connectedCallback() {
      this.offers = Array.from(this.querySelectorAll('[data-offer]'));
      this.cta = this.querySelector('[data-buy-now]');
      this.addAnother = this.querySelector('[data-add-another]');
      this.addAnotherChoices = Array.from(this.querySelectorAll('[data-add-another-choice]'));
      this.addAnotherChoice = null;
      if (!this.offers.length || !this.cta) return;

      this.offers.forEach((offer) => {
        offer.addEventListener('click', () => this.select(offer));
        offer.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.select(offer);
          }
        });
      });

      this.addAnotherChoices.forEach((choice) => {
        choice.addEventListener('click', () => this.selectAddAnother(choice.dataset.addAnotherChoice));
      });

      this.cta.addEventListener('click', () => this.checkout());
      this.updateCta();
    }

    select(offer) {
      const previousType = this.selectedOffer()?.dataset.offerType;

      this.offers.forEach((item) => {
        const selected = item === offer;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', String(selected));
      });

      if (previousType !== offer.dataset.offerType) {
        this.resetAddAnother();
      }

      this.updateCta();
    }

    selectAddAnother(choice) {
      this.addAnotherChoice = choice;
      this.addAnotherChoices.forEach((item) => {
        const selected = item.dataset.addAnotherChoice === choice;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      this.updateCta();
    }

    resetAddAnother() {
      this.addAnotherChoice = null;
      this.addAnotherChoices.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
    }

    selectedOffer() {
      return this.offers.find((offer) => offer.classList.contains('is-selected')) || this.offers[0];
    }

    selectedQuantity(offer = this.selectedOffer()) {
      return offer?.dataset.offerType === 'book' && this.addAnotherChoice === 'yes' ? 2 : 1;
    }

    updateCta() {
      const offer = this.selectedOffer();
      const isBook = offer?.dataset.offerType === 'book';

      if (this.addAnother) {
        this.addAnother.hidden = !isBook;
      }

      if (isBook && this.addAnotherChoice === 'yes') {
        this.cta.textContent = this.copiesLabel();
      } else {
        this.cta.textContent = isBook ? this.dataset.ctaBook || 'BUY BOOK' : this.dataset.ctaBundle || 'BUY BUNDLE';
      }

      this.cta.disabled = offer?.dataset.available !== 'true';
    }

    copiesLabel() {
      const label = this.dataset.ctaBooks || 'SECURE YOUR COPIES';
      const price = this.multipliedPrice(this.dataset.addAnotherPrice, 2);
      return price ? `${label} - ${price}` : label;
    }

    multipliedPrice(priceText, quantity) {
      const text = (priceText || '').trim();
      const match = text.match(/^([^0-9-]*)(-?\d[\d,]*(?:\.\d+)?)(.*)$/);
      if (!match) return '';

      const amount = Number(match[2].replace(/,/g, ''));
      if (!Number.isFinite(amount)) return '';

      const decimalPlaces = match[2].includes('.') ? match[2].split('.')[1].length : 0;
      const value = amount * quantity;
      const formatted = value.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      });

      return `${match[1]}${formatted}${match[3]}`.trim();
    }

    async checkout() {
      const offer = this.selectedOffer();
      const variantId = Number(offer?.dataset.variantId);
      if (!variantId || offer.dataset.available !== 'true') return;
      const quantity = this.selectedQuantity(offer);

      this.cta.disabled = true;
      const root = this.dataset.checkoutRoot || '/';
      const clearCart = this.dataset.clearCart !== 'false';

      try {
        if (clearCart) {
          await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
        }
        const add = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (!add.ok) throw new Error('add');
        window.location.href = `${root}checkout`;
      } catch {
        window.location.href = `${root}cart/${variantId}:${quantity}`;
      }
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('offer-selector')) customElements.define('offer-selector', OfferSelector);

  function initDescriptionToggle(section) {
    const wrap = section.querySelector('[data-description-wrap]');
    const button = section.querySelector('[data-description-toggle]');
    if (!wrap || !button) return;

    const labelClosed = button.querySelector('[data-description-label-closed]');
    const labelOpen = button.querySelector('[data-description-label-open]');

    button.addEventListener('click', () => {
      const open = wrap.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      if (labelClosed) labelClosed.hidden = open;
      if (labelOpen) labelOpen.hidden = !open;
    });
  }

  function initStickyChooseOffer(section) {
    if (!section.classList.contains('landing-product--sticky-cta')) return;

    const offers = section.querySelector('[data-offers-anchor]');
    const bar = section.querySelector('[data-choose-offer-bar]');
    const button = section.querySelector('[data-choose-offer]');
    if (!offers || !bar || !button) return;

    const mediaQuery = window.matchMedia('(max-width: 899px)');

    const update = () => {
      if (!mediaQuery.matches) {
        bar.classList.remove('is-visible');
        return;
      }

      const rect = offers.getBoundingClientRect();
      const scrolledPast = rect.bottom < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    };

    button.addEventListener('click', () => {
      offers.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    mediaQuery.addEventListener('change', update);
    update();
  }

  function initPreorderModal(section) {
    const trigger = section.querySelector('[data-bonus-trigger]');
    const modal = section.querySelector('[data-preorder-modal]');
    const dialog = modal?.querySelector('[role="dialog"]');
    if (!trigger || !modal || !dialog) return;

    const closeButtons = Array.from(modal.querySelectorAll('[data-preorder-close]'));
    let lastFocused = null;

    const focusableSelector = [
      'button:not([disabled])',
      '[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    const getFocusable = () => Array.from(modal.querySelectorAll(focusableSelector));

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('preorder-modal-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      lastFocused?.focus?.();
    };

    const open = () => {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('preorder-modal-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', onKeydown);
      requestAnimationFrame(() => dialog.focus());
    };

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    trigger.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
  }

  function initLandingProduct(section) {
    if (!section || section.dataset.landingReady === 'true') return;
    section.dataset.landingReady = 'true';
    initDescriptionToggle(section);
    initStickyChooseOffer(section);
    initPreorderModal(section);
  }

  function bootLandingProducts() {
    document.querySelectorAll('.landing-product').forEach(initLandingProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLandingProducts);
  } else {
    bootLandingProducts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('.landing-product') || event.target.closest?.('.landing-product');
    if (section) {
      section.dataset.landingReady = 'false';
      initLandingProduct(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
